export default "__VITE_ASSET__CVSy1ND5__"